import { render, staticRenderFns } from "./column-sorting-component.vue?vue&type=template&id=4a91b8f6"
import script from "./column-sorting-component.vue?vue&type=script&lang=ts"
export * from "./column-sorting-component.vue?vue&type=script&lang=ts"
import style0 from "./column-sorting-component.vue?vue&type=style&index=0&id=4a91b8f6&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a91b8f6')) {
      api.createRecord('4a91b8f6', component.options)
    } else {
      api.reload('4a91b8f6', component.options)
    }
    module.hot.accept("./column-sorting-component.vue?vue&type=template&id=4a91b8f6", function () {
      api.rerender('4a91b8f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/outage-clock/scorecard/column-sorting/column-sorting-component.vue"
export default component.exports